import React, {Component} from 'react';

class Footer extends Component {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        return (

            <div className="template-footer">



                <div className="template-footer-bottom">
                    <div className="template-align-center template-main">
                        <div
                            className="template-component-social-icon template-component-social-icon-style-1 template-clear-fix template-margin-bottom-2">
                            <ul>

                                <li><a href="#" className="template-component-social-icon-linkedin"></a></li>
                                <li><a href="https://www.instagram.com/turuncumontessori/" className="template-component-social-icon-instagram"></a></li>
                                <li><a href="#" className="template-component-social-icon-facebook"></a></li>
                                <li><a href="https://twitter.com/TuruncuOkul" className="template-component-social-icon-twitter"></a></li>
                            </ul>
                        </div>
                        <div>
                            &copy;&nbsp;
                            <a href="#">2020 Turuncu Montessori Anaokulu</a>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Footer;
